import { useAppDispatch } from "@/redux/store";
import { useSelector } from "react-redux";
import { getReserveGrunts } from "@/redux/profile/grunt/selectors";
import { fetchAllGruntReserve } from "@/redux/profile/grunt/asyncAction";
import Styles from "./GruntReserved.module.scss"
import { GruntListSkeleton } from "./GruntListSkeleton";
import GruntItem from "../GruntItem/GruntItem";
import React, {useEffect} from "react";

const GruntList:React.FC = () => {
  const dispatch = useAppDispatch();
  const {isLoading, items} = useSelector(getReserveGrunts)

  useEffect(() => {
    dispatch(fetchAllGruntReserve());
  }, [])


  return(
    <div>
      {
        isLoading? (
          <GruntListSkeleton />
        ) : (
          <>
            <p className={Styles.subTitile}>Список грунтов</p>
            <div className={Styles.item}>
              {items.map((item) => <GruntItem data={item}/> )}
            </div>
          </>
        )
      }
    </div>
  )
}

export default GruntList
